import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const JuridicoIndex = lazy(() => import('./Index'));
const JuridicoDashboard = lazy(() => import('./Dashboard'));
const JuridicoForm = lazy(() => import('./Form'));

const JuridicoAdmin = () => (
    <div className="panel max-w-2xl mx-auto text-center py-14">
        <h2 className="text-base font-semibold text-gray-900 dark:text-white">Administração Jurídico</h2>
        <p className="text-xs text-gray-500 dark:text-white-dark mt-1">Funcionalidades administrativas em breve.</p>
    </div>
);

export const juridicoRoutes: RouteObject[] = [
    {
        path: '/juridico',
        element: (
            <ProtectedRoute permission="juridico.view">
                <JuridicoIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/juridico/dashboard',
        element: (
            <ProtectedRoute permission="juridico.view">
                <JuridicoDashboard />
            </ProtectedRoute>
        ),
    },
    {
        path: '/juridico/novo',
        element: (
            <ProtectedRoute permission="juridico.create">
                <JuridicoForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/juridico/:id',
        element: (
            <ProtectedRoute permission="juridico.view">
                <JuridicoForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/juridico/:id/editar',
        element: (
            <ProtectedRoute permission="juridico.view">
                <JuridicoForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/juridico/admin',
        element: (
            <ProtectedRoute permission="juridico.admin">
                <JuridicoAdmin />
            </ProtectedRoute>
        ),
    },
];
